// extracted by mini-css-extract-plugin
export default {"container":"Footer_container__-04sv","leftContainer":"Footer_leftContainer__k0LuK","rightContainer":"Footer_rightContainer__synpN","line":"Footer_line__e5BJt"};